import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useChatColors } from './chatStyles';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { SVG_COMPONENTS as ADMIN_SVG_COMPONENTS } from '@/assets/admin';
import { ReplyToInfo } from '@/types/residents/marketplaceListing';

const CloseIcon = ADMIN_SVG_COMPONENTS.X_CIRCLE;
const ReplyArrowIcon = RESIDENTS_SVG_COMPONENTS.REPLY_ARROW;

interface ReplyPreviewProps {
  replyTo: ReplyToInfo;
  onClear: () => void;
}

/**
 * Reply preview bar shown above the chat input when replying to a message
 */
export const ReplyPreview: React.FC<ReplyPreviewProps> = ({ replyTo, onClear }) => {
  const chatColors = useChatColors();

  const truncatedText = replyTo.text.length > 100
    ? `${replyTo.text.substring(0, 100)}...`
    : replyTo.text;

  return (
    <View style={[styles.container, {
      backgroundColor: chatColors.messageBubbleReceived,
      borderLeftColor: chatColors.accentBlueDark,
    }]}>
      <View style={styles.iconContainer}>
        <ReplyArrowIcon width={16} height={16} color={chatColors.accentBlueDark} />
      </View>
      <View style={styles.contentContainer}>
        <Text style={[styles.senderName, { color: chatColors.accentBlueDark }]} numberOfLines={1}>
          Replying to {replyTo.senderName}
        </Text>
        <Text style={[styles.messageText, { color: chatColors.textSecondary }]} numberOfLines={1}>
          {truncatedText || '(Image)'}
        </Text>
      </View>
      <TouchableOpacity
        style={styles.closeButton}
        onPress={onClear}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      >
        <CloseIcon width={16} height={16} color={chatColors.textMuted} />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderLeftWidth: 3,
    marginHorizontal: 16,
    marginBottom: 8,
    borderRadius: 8,
    gap: 12,
  },
  iconContainer: {
    width: 24,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    flex: 1,
    gap: 2,
  },
  senderName: {
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 16,
  },
  messageText: {
    fontSize: 13,
    fontWeight: '400',
    lineHeight: 18,
  },
  closeButton: {
    width: 24,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
